export default __webpack_public_path__ + "static/media/9_16-clip-mobile.0b5f8c5a.png";